// extracted by mini-css-extract-plugin
module.exports = {"getStarted":"GetStartedSection_getStarted__5kvdI","getStartedContent":"GetStartedSection_getStartedContent__IL9b1"};